/**
 * @file 主页面layout
 * @author liwei.zhu
 */
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { Layout, Breadcrumb, Spin, Icon } from 'antd';
import PropTypes from 'prop-types';
import qs from 'qs';
import { inject } from 'mobx-react';
import { observable, action } from 'mobx';
import routerList from 'routers';

import can from 'pages/common/decorators/can';

import SiderMenu from './components/siderMenu';
import GlobalHeader from './components/globalHeader';
import Router from './router';
import style from './index.less';

const { Content } = Layout;

@can()
@inject('globalStore')
export default class Main extends Component {
    @observable pageTitle = '分销运营平台';
    static propTypes = {
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
    };
    static childContextTypes = {
        location: PropTypes.shape({}),
        query: PropTypes.shape({}),
    };

    getChildContext() {
        const { location } = this.props;
        const query = qs.parse(location.search.substr(1));

        return { location, query };
    }

    componentDidMount() {
        this.props.globalStore.getUserInfo();
    }

    getCurrentRoute() {
        // 获取当前路径信息
        const { location } = this.props;
        if (!location || !location.pathname || location.pathname.length < 3) {
            return null;
        }

        const pathArr = location.pathname.split('/');
        const oneLevel = routerList.filter(val => {
            return val.path == '/' + pathArr[1];
        });

        if (!oneLevel || !oneLevel[0] || !oneLevel[0].children) {
            return null;
        }
        const twoLevel = oneLevel[0].children.filter(val => {
            const temp = val.path.split('/')[0];
            return temp == pathArr[2];
        });

        return {
            oneLevel,
            twoLevel,
        };
    }

    @action
    getBreadcrumb() {
        // 面包屑获取当前页面名称
        const currentRoute = this.getCurrentRoute();
        if (!currentRoute) { return null; }
        const { can } = this.props;
        const { oneLevel, twoLevel } = currentRoute;
        if (
            oneLevel[0].name &&
            twoLevel[0].name &&
            (!twoLevel[0].permission ||
                (twoLevel[0].permission &&
                    can(twoLevel[0].permission)
                )
            )
        ) {
            this.pageTitle = twoLevel[0].name;
            return (
                <div className={style.breadcrumbWrap}>
                    <Icon
                        type="arrow-left"
                        className={style.breadcrumbIcon}
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    />
                    <Breadcrumb className={style.breadcrumb}>
                        <Breadcrumb.Item>{oneLevel[0].name}</Breadcrumb.Item>
                        <Breadcrumb.Item>{twoLevel[0].name}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            );
        }
        return null;
    }

    render() {
        const { isLogin } = this.props.globalStore;
        const spin = <Spin size="large" className={style.spin} />;
        const layout = (
            <Layout style={{ minWidth: 1200 }}>
                <SiderMenu {...this.props} />
                <Layout>
                    <GlobalHeader {...this.props} />
                    <Content style={{ overflow: 'hidden' }}>
                        
                        {this.getBreadcrumb()}
                        <div className={style.mainContent}>
                            <div className={style.content}>
                                <Router {...this.props} />
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );

        return (
            <DocumentTitle title={this.pageTitle}>
                {isLogin ? layout : spin}
            </DocumentTitle>
        );
    }
}
